import useRequest from '@/websdk/utils/request';
import moment from 'moment';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/order/count?start_time=' + moment().startOf('month').unix() + '&end_time=' + moment().endOf('month').unix(),
    name: 'productionCountGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
